module.exports = __webpack_public_path__ + "img/coupon_btn.c9eff74e.png";